export default "__VITE_ASSET__4GpW1erx__"